import React from "react";
import styled from 'styled-components';
import moment from "moment";
import { commentStatusEnum } from "constants/globalEnum";

const SUserIcon = styled.div`
    border-radius: 50%;
    width: 30px;
    height: 30px;
    background-color: #55ca38;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SLayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
`;

const SFlexRow = styled.div`
    display: flex;
    align-items: center;
`;

const MyMessage = ({ text, timeDuration, updatedBy }) => {
    return (
        <div style={{ textAlign: 'right' }}>
            <SFlexRow style={{ gap: 10, marginBottom: 5, justifyContent: 'end' }}>
                <div>{timeDuration}</div>
                <div>{updatedBy}</div>
                <SUserIcon>
                    {updatedBy.charAt(0).toUpperCase()}
                </SUserIcon>
            </SFlexRow>
            <div style={{ marginRight: 40 }}>
                <div>{text}</div>
            </div>
        </div>
    );
};

const CommentMessage = ({
    text,
    lastUpdated,
    updatedBy,
    isMyMessage = false,
    status,
    editStatus,
}) => {

    const getDuration = (lastUpdated) => {
        const now = moment();
        const duration = moment.duration(now.diff(moment(lastUpdated)));
        return `${duration.humanize()} ago`;
    };

    if (isMyMessage) {
        return <MyMessage text={text} updatedBy={updatedBy} timeDuration={getDuration(lastUpdated)} />;
    }

    const handleStatus = () => {
        let res = '';
        if (status === commentStatusEnum.ACCEPTED) {
            res = `(Accepted) `;
        }
        if (status === commentStatusEnum.REJECTED) {
            res = `(Rejected) `;
        }
        return res;
    }

    return (
        <SLayoutContainer>
            <SFlexRow style={{ gap: 10, marginBottom: 5 }}>
                <SUserIcon>
                    {updatedBy.charAt(0).toUpperCase()}
                </SUserIcon>
                <div>{updatedBy}</div>
                <div>{getDuration(lastUpdated)}</div>
            </SFlexRow>
            {
                !editStatus &&
                <div style={{ marginLeft: 40 }}>
                    <div style={{ width: '360px', wordBreak: 'break-all' }}>
                        {handleStatus()}{text}
                    </div>
                </div>
            }

        </SLayoutContainer>
    );
};

export default CommentMessage;